
(function() {
  var result = { translations: { "nl": { "foundations-components": { "ActionsMenu": { "defaultAriaLabel": "Acties" }, "tag": { "remove": "Tag verwijderen" }, "Select": { "noResults": "Geen resultaten gevonden", "searchPlaceholder": "Zoeken...", "clearSelections": "Selecties wissen" }, "ErrorMessage": { "error": { "title": "Er is nog hoop." }, "notFound": { "title": "Als je ronddwaalt, wil dat nog niet zeggen dat je verdwaald bent." }, "badRequest": { "title": "Er is een probleem opgetreden bij het laden van deze pagina." }, "expired": { "title": "Excuses." }, "sessionId": { "prefix": "Sessie-id:" } }, "ProgressSteps": { "completedStep": "Voltooide stap", "incompleteStep": "Onvoltooide stap" }, "Paginator": { "label": "Paginering", "pageNumber": { "currentIndicator": "Je bent momenteel op", "description": "Pagina" }, "firstPage": { "label": "Eerste", "description": "Eerste pagina" }, "previousPage": { "label": "Vorige", "description": "Vorige pagina" }, "nextPage": { "label": "Volgende", "description": "Volgende pagina" }, "lastPage": { "label": "Laatste", "description": "Laatste pagina" } }, "Datagrid": { "noData": { "Title": "Geen gegevens beschikbaar", "Description": "Er zijn geen gegevens beschikbaar om weer te geven." }, "noResults": { "Title": "Geen resultaten gevonden", "Description": "Probeer je zoekopdracht en filters te wijzigen om te vinden wat je zoekt.", "ClearActionLabel": "Zoekopdracht en filters wissen" }, "toolbar": { "selectedRows": { "one": "{{count}} rij geselecteerd", "other": "{{count}} rijen geselecteerd", "clearSelection": "Selectie wissen", "selectAll": "Selecteer alle {{totalRows}} rijen" }, "search": { "placeholder": "Zoeken", "label": "Zoeken", "clearSearch": "Zoekopdracht wissen" } }, "pagination": { "visibleRows": "{{visibleRows}} van {{totalRows}} resultaten", "itemsPerPage": "Items per pagina", "countPerPage": { "one": "{{count}} per pagina", "other": "{{count}} per pagina" } }, "SkeletonGrid": { "loading": "Wordt geladen" }, "DataGridColumnManagementPanel": { "description": "Kies welke eigenschappen je als kolommen wilt weergeven. Verplaats vervolgens eigenschappen omhoog of omlaag, of versleep ze, om de volgorde waarin ze worden weergegeven te wijzigen.", "removeAllColumns": "Alle kolommen verwijderen", "update": "Bijwerken", "cancel": "Annuleren", "edit": "Kolommen bewerken" } } }, "ui": { "UIAbstractPageSection": { "page": "Paginarubriek" }, "UICarousel": { "current": "Item {{currentStepDisplayNumber}} van {{totalSteps}}wordt weergegeven", "prev": "Vorige", "next": "Volgende", "tip": "Gebruik de pijltoetsen om andere items weer te geven" }, "UIColorSwatch": { "label": "Kleurkiezer {{value}}", "noColorLabel": "Kleurkiezer, geen kleur geselecteerd." }, "UIButtonCollapser": { "dropdownLabel": "Acties" }, "UIErrorMessage": { "error": { "title": "Er is nog hoop." }, "notFound": { "title": "Als je ronddwaalt, wil dat nog niet zeggen dat je verdwaald bent." }, "badRequest": { "title": "Er is een probleem opgetreden bij het laden van deze pagina." }, "expired": { "title": "Het spijt ons." } }, "UIPanelNavigator": { "backButton": "Naar het vorige scherm gaan" }, "UILoadingSpinner": { "busyText": "Wordt geladen", "completedText": "Geladen" }, "UISideNav": { "navigationLandmark": "Secundair" }, "UISortTH": { "ascendingSort": "Oplopend sorteren. Selecteer om aflopend te sorteren.", "descendingSort": "Aflopend sorteren. Selecteer om oplopend te sorteren.", "pressToSort": "Selecteer om te sorteren." }, "autosizedTextInput": { "charactersRemaining": "{{value}} tekens resterend" }, "time": { "today": "Vandaag om {{time}}", "yesterday": "Gisteren om {{time}}", "datetime": "{{date}} om {{time}}" }, "progress": { "percentComplete": "{{percent}} voltooid" }, "datePicker": { "dateSelected": "{{date}} is geselecteerd.", "noDateSelected": "Geen datum geselecteerd.", "dateBelowMin": "Je moet een recentere datum kiezen", "dateAboveMax": "Je moet een eerdere datum kiezen", "invalidDate": "Ongeldige datum", "today": "Vandaag", "clear": "Wissen", "placeholder": { "month": "MM", "day": "DD", "year": "JJJJ" }, "nextMonth": "Volgende maand", "prevMonth": "Voorgaande maand" }, "dateRange": { "startDate": "Startdatum", "endDate": "Einddatum", "endDateBeforeStartDate": "De einddatum moet na de startdatum liggen.", "startDateAfterEndDate": "De startdatum moet voor de einddatum liggen.", "to": "aan" }, "timePicker": { "placeholder": { "hour": "UU", "minute": "MM" } }, "SelectResultList": { "andMore": ".. nog {{count}}.", "loadMore": "Meer laden" } }, "salesUI": { "UIAvatarAdd": { "ariaLabel": "Toevoegen" }, "UIAvatarHoverlay": { "text": "Foto wijzigen" }, "UIChangeArrow": { "decrease": "Afname van", "increase": "Toename van" }, "UICopyInput": { "label": "Kopi\xEBren", "title": "Kopi\xEBren naar klembord", "tooltipCopied": "Gekopieerd" }, "UIConfirm": { "defaultConfirm": "Ja", "defaultReject": "Nee" }, "UICloseButton": { "label": "Sluiten" }, "UIDateRangePicker": { "rangeType": { "ALL": "De hele tijd", "THIS_DAY": "Vandaag", "LAST_DAY": "Gisteren", "THIS_WEEK": "Deze week", "LAST_WEEK": "Vorige week", "THIS_MONTH": "Deze maand", "LAST_MONTH": "Vorige maand", "LAST_THIRTY_DAYS": "Afgelopen 30 dagen", "LAST_THREE_MONTHS": "Laatste 3 maanden", "THIS_QUARTER": "Dit kwartaal", "LAST_QUARTER": "Vorig kwartaal", "THIS_YEAR": "Dit jaar", "LAST_YEAR": "Vorig jaar", "CUSTOM": "Aangepaste tijdsperiode" } }, "UIDropdownSelect": { "placeholder": "Geen waarde geselecteerd" }, "UIEditableControls": { "cancel": "Annuleren", "save": "Opslaan" }, "UIExpandableText": { "collapseButtonText": "Zie minder", "expandButtonText": "Meer weergeven" }, "UIFileInput": { "defaultChangeLabel": "Bestand wijzigen", "defaultSelectLabel": "Bestand kiezen" }, "UIIconRating": { "ariaValueText": "{{value}} van de {{maxValue}}" }, "UILink": { "externalTitle": "Link wordt in een nieuw venster geopend" }, "UILoading": { "title": "Bezig met laden..." }, "UILockBadge": { "title": "Deze functie is vergrendeld" }, "UIPaginator": { "label": "Paginering", "pageNumber": { "currentIndicator": "Je bent momenteel op", "description": "Pagina" }, "firstPage": { "label": "Eerste", "description": "Eerste pagina" }, "previousPage": { "label": "Vorige", "description": "Vorige pagina" }, "nextPage": { "label": "Volgende", "description": "Volgende pagina" }, "lastPage": { "label": "Laatste", "description": "Laatste pagina" } }, "UIPreviousButton": { "label": "Vorige" }, "UINextButton": { "label": "Volgende" }, "UINumberRating": { "lowRangeLabel": "Zeer oneens", "highRangeLabel": "Helemaal mee eens" }, "UISearchableSelectInput": { "placeholder": "Zoeken" }, "UISearchInput": { "placeholder": "Zoeken", "minimumSearchMessage": { "one": "Typ nog 1 teken", "other": "Typ nog {{count}} tekens" }, "clearButton": "Invoer wissen" }, "UISelect": { "allOptionsSelected": "Alle opties zijn geselecteerd", "createOption": "Optie \"{{label}}\" aanmaken", "plusMore": "+ nog {{count}}", "andMore": "...nog {{count}}.", "loadMore": "Meer laden", "noResults": "Geen resultaten gevonden", "placeholder": "Zoeken", "typeToSearch": "Typ om te zoeken" }, "UITable": { "selectableTableRow": { "toggleSelection": "Schakelen tussen geselecteerde rijen" } }, "UITabs": { "moreDropdownLabel": "Meer" }, "UITeaseNotification": { "optionsButtonTooltipText": "Opties weergeven" }, "UITimePicker": { "placeholder": "Een tijd selecteren" }, "UIToggle": { "checkedLabel": "AAN", "uncheckedLabel": "UIT" }, "UITypeahead": { "noMatchesFound": "Geen overeenkomsten gevonden", "noOptions": "Geen" }, "UIWizard": { "back": "Vorige", "cancel": "Annuleren", "done": "Klaar", "next": "Volgende", "stepCount": "Stap {{stepNumber}} van de {{stepCount}}" }, "XSSTooltip": { "explanation": "Deze link is uitgeschakeld voor je veiligheid." } } } } };
  result.translationsLoaded = {
  "foundations-components": {
    "nl": "static-1.5789"
  }
};
  result.translationsAvailable = {
  "foundations-components": {
    "af": "static-1.5789",
    "ar-eg": "static-1.5789",
    "bg": "static-1.5789",
    "bn": "static-1.5789",
    "ca-es": "static-1.5789",
    "cs": "static-1.5789",
    "da": "static-1.5789",
    "de": "static-1.5789",
    "el": "static-1.5789",
    "en-gb": "static-1.5789",
    "en": "static-1.5789",
    "es-mx": "static-1.5789",
    "es": "static-1.5789",
    "et": "static-1.5789",
    "fi": "static-1.5789",
    "fr-ca": "static-1.5789",
    "fr": "static-1.5789",
    "he-il": "static-1.5789",
    "hi": "static-1.5789",
    "hr": "static-1.5789",
    "hu": "static-1.5789",
    "id": "static-1.5789",
    "it": "static-1.5789",
    "ja": "static-1.5789",
    "ko": "static-1.5789",
    "lt": "static-1.5789",
    "ms": "static-1.5789",
    "nl": "static-1.5789",
    "no": "static-1.5789",
    "pl": "static-1.5789",
    "pt-br": "static-1.5789",
    "pt-pt": "static-1.5789",
    "ro": "static-1.5789",
    "ru": "static-1.5789",
    "sk": "static-1.5789",
    "sl": "static-1.5789",
    "sv": "static-1.5789",
    "th": "static-1.5789",
    "tl": "static-1.5789",
    "tr": "static-1.5789",
    "uk": "static-1.5789",
    "vi": "static-1.5789",
    "zh-cn": "static-1.5789",
    "zh-hk": "static-1.5789",
    "zh-tw": "static-1.5789"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:foundations-components:nl', {version: 'static-1.5789'}); }
})();



(function() {
  var result = { translations: { "nl": { "placeholder": "tijdelijke aanduiding" } } };
  result.translationsLoaded = {
  "UIComponents": {
    "nl": "static-3.7060"
  }
};
  result.translationsAvailable = {
  "UIComponents": {
    "af": "static-3.7060",
    "ar-eg": "static-3.7060",
    "bg": "static-3.7060",
    "bn": "static-3.7060",
    "ca-es": "static-3.7060",
    "cs": "static-3.7060",
    "da": "static-3.7060",
    "de": "static-3.7060",
    "el": "static-3.7060",
    "en-gb": "static-3.7060",
    "en": "static-3.7060",
    "es-mx": "static-3.7060",
    "es": "static-3.7060",
    "et": "static-3.7060",
    "fi": "static-3.7060",
    "fr-ca": "static-3.7060",
    "fr": "static-3.7060",
    "he-il": "static-3.7060",
    "hi": "static-3.7060",
    "hr": "static-3.7060",
    "hu": "static-3.7060",
    "id": "static-3.7060",
    "it": "static-3.7060",
    "ja": "static-3.7060",
    "ko": "static-3.7060",
    "lt": "static-3.7060",
    "ms": "static-3.7060",
    "nl": "static-3.7060",
    "no": "static-3.7060",
    "pl": "static-3.7060",
    "pt-br": "static-3.7060",
    "pt-pt": "static-3.7060",
    "ro": "static-3.7060",
    "ru": "static-3.7060",
    "sk": "static-3.7060",
    "sl": "static-3.7060",
    "sv": "static-3.7060",
    "th": "static-3.7060",
    "tl": "static-3.7060",
    "tr": "static-3.7060",
    "uk": "static-3.7060",
    "vi": "static-3.7060",
    "zh-cn": "static-3.7060",
    "zh-hk": "static-3.7060",
    "zh-tw": "static-3.7060"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:UIComponents:nl', {version: 'static-3.7060'}); }
})();



(function() {
  var result = { translations: { "nl": { "app": { "htmlTitle": "Virale links gebruikersinterface", "welcomeHome": "Welkom thuis, {{ firstName }}", "yourAppIsReady": "Je app is klaar", "aSecondPage": "Een tweede pagina voor meer inhoud", "fillPage_jsx": function (createElement, options, props) { return createElement( options, "wrapper", null, "Vul deze lege pagina met ", createElement( options, "Link", props.linkProps, "onderdelen" ), " op ", createElement( options, "code", null, props.filename ), "." ); }, "viralLinks": { "forms": { "linkCta": "<strong>Cre\xEBer je eigen gratis formulieren</strong> om leads te genereren op je website." }, "liveChat": { "linkCta": "<strong>Voeg live chat toe.</strong> Maak contact met bezoekers. Gratis.", "ariaLabel": "Voeg live chat toe. Maak contact met bezoekers. Gratis." }, "liveChatIntermediate": { "linkCta": "<strong>[Int] Voeg live chat toe.</strong> Maak contact met bezoekers. Gratis.", "ariaLabel": "[Int] Voeg live chat toe. Maak contact met bezoekers. Gratis." }, "meetings": { "linkCta": "<strong>Maak je gratis pagina om meetings te boeken</strong> om sneller meetings te plannen." } } } } } };
  result.translationsLoaded = {
  "embedded-viral-link-ui": {
    "nl": "static-1.4843"
  }
};
  result.translationsAvailable = {
  "embedded-viral-link-ui": {
    "af": "static-1.4843",
    "ar-eg": "static-1.4843",
    "bg": "static-1.4843",
    "bn": "static-1.4843",
    "ca-es": "static-1.4843",
    "cs": "static-1.4843",
    "da": "static-1.4843",
    "de": "static-1.4843",
    "el": "static-1.4843",
    "en-gb": "static-1.4843",
    "en": "static-1.4843",
    "es-mx": "static-1.4843",
    "es": "static-1.4843",
    "et": "static-1.4843",
    "fi": "static-1.4843",
    "fr-ca": "static-1.4843",
    "fr": "static-1.4843",
    "he-il": "static-1.4843",
    "hi": "static-1.4843",
    "hr": "static-1.4843",
    "hu": "static-1.4843",
    "id": "static-1.4843",
    "it": "static-1.4843",
    "ja": "static-1.4843",
    "ko": "static-1.4843",
    "lt": "static-1.4843",
    "ms": "static-1.4843",
    "nl": "static-1.4843",
    "no": "static-1.4843",
    "pl": "static-1.4843",
    "pt-br": "static-1.4843",
    "pt-pt": "static-1.4843",
    "ro": "static-1.4843",
    "ru": "static-1.4843",
    "sk": "static-1.4843",
    "sl": "static-1.4843",
    "sv": "static-1.4843",
    "th": "static-1.4843",
    "tl": "static-1.4843",
    "tr": "static-1.4843",
    "uk": "static-1.4843",
    "vi": "static-1.4843",
    "zh-cn": "static-1.4843",
    "zh-hk": "static-1.4843",
    "zh-tw": "static-1.4843"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:embedded-viral-link-ui:nl', {version: 'static-1.4843'}); }
})();


